import { useLocale } from "@reco/shared/src/composables/useLocale";

export default defineNuxtRouteMiddleware(() => {
  const { $i18n } = useNuxtApp();
  const { locale } = useLocale();

  type ValidLocale = Parameters<typeof $i18n.setLocale>[0];

  if (locale.value && $i18n.locale.value !== locale.value) {
    return $i18n.setLocale(locale.value as ValidLocale);
  }
});
